import React from 'react';

import { Button } from '~components';

import { PaymentBatchClient } from '~direct-debits/models';

interface ComponentProps {
  row: PaymentBatchClient;
  onViewInvoices?: (clientId: number) => void;
}

const BatchClientRowAction: React.FC<ComponentProps> = ({ row, onViewInvoices }) => {
  const disabled = !onViewInvoices || row.invoice_count === 0;
  return (
    <Button
      id={`dd-payment-batch-client-view-${row.client_id}`}
      data-cy={`dd-payment-batch-client-view-${row.client_id}`}
      size="sm"
      color="primary"
      outline
      disabled={disabled}
      onClick={() => onViewInvoices?.(row.client_id)}
    >
      View Invoices
    </Button>
  );
};

export default BatchClientRowAction;
